import script from "./ImageBackDiv.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageBackDiv.vue?vue&type=script&lang=ts&setup=true"

import "./ImageBackDiv.vue?vue&type=style&index=0&id=b8660f0a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8660f0a"]])

export default __exports__